/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PurchaseCancelInfoVo } from './PurchaseCancelInfoVo';
import {
    PurchaseCancelInfoVoFromJSON,
    PurchaseCancelInfoVoFromJSONTyped,
    PurchaseCancelInfoVoToJSON,
    PurchaseCancelInfoVoToJSONTyped,
} from './PurchaseCancelInfoVo';

/**
 * 
 * @export
 * @interface ResponsePurchaseCancelInfoVo
 */
export interface ResponsePurchaseCancelInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePurchaseCancelInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePurchaseCancelInfoVo
     */
    message?: string;
    /**
     * 
     * @type {PurchaseCancelInfoVo}
     * @memberof ResponsePurchaseCancelInfoVo
     */
    data?: PurchaseCancelInfoVo;
}

/**
 * Check if a given object implements the ResponsePurchaseCancelInfoVo interface.
 */
export function instanceOfResponsePurchaseCancelInfoVo(value: object): value is ResponsePurchaseCancelInfoVo {
    return true;
}

export function ResponsePurchaseCancelInfoVoFromJSON(json: any): ResponsePurchaseCancelInfoVo {
    return ResponsePurchaseCancelInfoVoFromJSONTyped(json, false);
}

export function ResponsePurchaseCancelInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePurchaseCancelInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PurchaseCancelInfoVoFromJSON(json['data']),
    };
}

export function ResponsePurchaseCancelInfoVoToJSON(json: any): ResponsePurchaseCancelInfoVo {
    return ResponsePurchaseCancelInfoVoToJSONTyped(json, false);
}

export function ResponsePurchaseCancelInfoVoToJSONTyped(value?: ResponsePurchaseCancelInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PurchaseCancelInfoVoToJSON(value['data']),
    };
}

